import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/libs/react-query';
export const ReactQueryProvider = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, children);
};